__turbopack_context__.v({
  "root": "Spinner-module__5juMiG__root",
  "spinnerImage": "Spinner-module__5juMiG__spinnerImage",
});
